export default "__VITE_ASSET__BIV2rKtx__"